import { Component, Input, TemplateRef } from '@angular/core';

import { LssEntity } from '../../configuration/store/lss-entity.datamodel';

@Component({
    selector: 'ama-ng-app-store-offices-list',
    templateUrl: './offices-list.component.html',
    styleUrls: ['./offices-list.component.scss'],
    standalone: false
})
export class OfficesListComponent<E extends LssEntity<E>> {
  @Input() itemTemplate!: TemplateRef<{ $implicit: E }>;
  @Input() headerTemplate?: TemplateRef<{ $implicit: E[] }>;
  @Input() offices: E[] = [];

  /**
   * Track by function for ngFor
   * @param _index Item index
   * @param entity LSS entity
   */
  trackByFn(_index: number, entity: E) {
    return entity.actor.actorName;
  }

  min(a: number, b: number): number {
    return Math.min(a, b);
  }
}
